import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import jN from "./MobileDashboard.module.css"; // Replace with your actual CSS module path
import BS from "@mui/material/Modal";
import zS from "@mui/material/Fade";
import wS from "@mui/material/Backdrop";
import { BallTriangle } from "react-loader-spinner"; // or your custom loader
import { CircularProgress } from "@mui/material";
import axiosInstance from "src/axiosInstance";
import { useAuth } from "src/hooks/useAuth";
import { Modal } from "@mui/material";

const MobileDashboard = () => {
  const { data: j } = useAuth();
  const navigate = useNavigate();
  const [b, setDashboardData] = useState(null);
  const [g, setRecentOrders] = useState([]);
  const [y, setLoading] = useState(true);
  const [c, setModalOpen] = useState(false);
  const [h, setNotifications] = useState([]);
  const [u, setHasNotification] = useState(false);
  const [z, setSearchTerm] = useState('');
  const [testModeModal, setTestModeModal] = useState(false);

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!j?._id) return;
      try {
        setLoading(true);
        const [detailsRes, ordersRes] = await Promise.all([
          axiosInstance.get('/shop/dashboard/card?period=today'),
          axiosInstance.get('/shop/dashboard/recent-orders')
        ]);
        setDashboardData(detailsRes.data.data);
        setRecentOrders(ordersRes.data.data.data);
      } catch (error) {
        console.error("Failed to fetch dashboard data", error);
        setDashboardData({});
        setRecentOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [j?._id]);

  const C = () => setModalOpen(!c);
  const N = (path) => navigate(path);
  const x = (value) => setSearchTerm(value);

  const filteredOrders = g.filter(order =>
    (order.customer_name && order.customer_name.toLowerCase().includes(z.toLowerCase())) ||
    (order.order_number && order.order_number.toLowerCase().includes(z.toLowerCase()))
  );

  const isLoading = y || b === null;

  // Helper for navigation with Test Mode check
  const guardedNavigate = (path) => {
    if (!j?.onboarded && path !== "/app/profile?edit=1") {
      setTestModeModal(true);
      return;
    }
    navigate(path);
  };

  return (
    <div className={jN["mobile-dashboard-container"]}>
      <div
        className={jN["banner-section"]}
        style={{
          backgroundImage: `url(${j?.store_image || "/assets/Supermarket.webp"})`,
          backgroundColor: "#af3585",
        }}
      >
        <div className={jN["banner-overlay"]} />
        <div className={jN["stripe-overlay"]} />

        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
            cursor: "pointer",
          }}
          onClick={C}
        >
          <i
            className={`bi bi-bell ${u ? jN["bell-animation"] : ""}`}
            style={{ color: "white", fontSize: "1.8rem" }}
          />
          {u && (
            <div
              className={jN["notification-dot"]}
              style={{
                position: "absolute",
                top: "4px",
                right: "4px",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "red",
              }}
            />
          )}
        </div>
      </div>

      <BS
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={c}
        onClose={C}
        closeAfterTransition
        BackdropComponent={wS}
        BackdropProps={{ timeout: 500 }}
      >
        <zS in={c}>
          <div className={jN["modal-wrapper"]}> {/* replace with _o or your modal style */}
            <h3 id="transition-modal-title" style={{ marginBottom: 20 }}>Notifications</h3>
            {h.length > 0 ? (
              <div className={jN["notification-list"]}>
                {h.map((e, a) => (
                  <div
                    key={e.id}
                    className={jN["notification-item"]}
                    style={{ animationDelay: `${0.1 * a}s` }}
                  >
                    <p className={jN["notification-message"]}>{e.message}</p>
                    <small className={jN["notification-timestamp"]}>{e.timestamp}</small>
                  </div>
                ))}
              </div>
            ) : (
              <p>No new notifications.</p>
            )}
          </div>
        </zS>
      </BS>

      <div className={jN["dashboard-main-card"]}>
        <div className={jN["store-info-header"]} style={{ paddingTop: "10px" }}>
          <div className={jN["store-logo-container"]}>
            {j?.store_logo ? (
              <img
                src={j.store_logo}
                alt="Store Logo"
                className={jN["store-logo-avatar"]}
              />
            ) : (
              <div className={jN["placeholder-logo-container"]}>
                <div className={jN["placeholder-logo-bg"]}>
                  <img
                    src={"/assets/icons/shop.svg"}
                    alt="Store Icon"
                    className={jN["placeholder-logo-icon"]}
                  />
                </div>
                <div className={jN["add-logo-button-floating"]} onClick={() => N("/app/profile?edit=1")}>+</div>
              </div>
            )}
          </div>
          <div
            className={jN["store-details-text"]}
            style={{ position: "relative", flex: 1 }}
          >
            {/* STATUS BADGE AND LOGIC */}
            {(!j?.onboarded) && (
              <>
                <div style={{ marginBottom: 8 }}>
                  <span style={{
                    background: '#e0e7ff', color: '#5b21b6', fontWeight: 600, fontSize: 14, borderRadius: 8, padding: '2px 12px'
                  }}>Test Mode</span>
                </div>
              </>
            )}
            {(j?.onboarded && j?.is_approved !== 'verified') && (
              <div style={{ marginBottom: 8 }}>
                <span style={{
                  background: '#fffbe5', color: '#f79009', fontWeight: 600, fontSize: 14, borderRadius: 8, padding: '2px 12px'
                }}>Awaiting approval</span>
              </div>
            )}
            {/* STORE NAME */}
            <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
              <h2 className={jN["store-name"]}>{j?.store_name || "Dashboard"}</h2>
            </div>
            {/* ADDRESS/COMPLETE PROFILE BUTTON LOGIC */}
            {(!j?.onboarded) ? (
              <button
                style={{
                  background: '#af3585', color: 'white', borderRadius: 8, padding: '10px 0', fontWeight: 500, fontSize: 16, cursor: 'pointer', width: '100%', marginTop: 10
                }}
                onClick={() => N('/app/profile?edit=1')}
              >
                Complete Profile
              </button>
            ) : (
              <p className={jN["store-address"]}>{j?.store_address || "Address not available"}</p>
            )}
          </div>
        </div>

        <div className={`${jN["dashboard-card"]} ${jN["account-details-card"]}`}>
          {isLoading ? (
            <>
              <div className={jN["card-left-column"]}>
                <div className={`${jN['placeholder-balance']} ${jN.shimmer}`} />
                <div className={`${jN['placeholder-label']} ${jN.shimmer}`} />
                <div className={`${jN['placeholder-button']} ${jN.shimmer}`} />
              </div>
              <div className={jN["card-right-column"]}>
                <div className={`${jN['placeholder-label']} ${jN.shimmer}`} />
                <div className={`${jN['placeholder-account-name']} ${jN.shimmer}`} />
                <div className={`${jN['placeholder-account-number']} ${jN.shimmer}`} />
              </div>
            </>
          ) : (
            <>
              <div className={jN["card-left-column"]}>
                <h3 className={jN["balance-amount"]}>
                  {`₦ ${b?.balance ? b.balance.toLocaleString() : "0"}`}
                </h3>
                <p className={jN["account-info-label"]}>Your Balance</p>
                <button className={jN["withdraw-button"]} onClick={() => N("/app/wallet/withdraw-fund")}>
                  Withdraw
                </button>
              </div>
              <div className={jN["card-right-column"]}>
                <p className={jN["account-info-label"]}>Account Details</p>
                {b?.account_details?.account_name && b.account_details.account_name !== 'undefined' && b.account_details.account_name !== '' ? (
                  <>
                    <p className={jN["account-info-value1"]}>{b.account_details.account_name}</p>
                    <p className={jN["account-info-value"]}>
                      {b.account_details.account_number && b.account_details.account_number !== 'undefined' && b.account_details.account_number !== '' ? `${b.account_details.account_number} - ${b.account_details.bank_name}` : "N/A"}
                    </p>
                  </>
                ) : (
                  <button className={jN["add-wallet-button"]} onClick={() => N("/app/profile?edit=1&bank=1")}>Add Wallet</button>
                )}
              </div>
            </>
          )}
        </div>

        <div className={jN["action-buttons-section"]}>
          {[{
            title: "Add Product",
            icon: "/assets/shapes.png",
            link: "/app/products",
            bgColor: "#FCE4EC",
          }, {
            title: "Wallet",
            icon: "/assets/wallet-2.svg",
            link: "/app/wallets",
            bgColor: "#E0F7FA",
          }, {
            title: "Confirm Orders",
            icon: "/assets/scan.svg",
            link: "/app/orders",
            bgColor: "#FFEBEE",
          }, {
            title: "Settings",
            icon: "/assets/setting-2.svg",
            link: "/app/settings",
            bgColor: "#FFFDE7",
          }].map((btn, idx) => (
            <div
              key={idx}
              className={jN["action-button"]}
              onClick={() => guardedNavigate(btn.link)}
            >
              <div
                style={{
                  backgroundColor: btn.bgColor,
                  width: "60px",
                  height: "60px",
                  borderRadius: "30%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                }}
              >
                <img src={btn.icon} alt={btn.title} style={{ width: 24, height: 24 }} />
              </div>
              <p>{btn.title}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={jN["recent-orders-card"]}>
        <h2 className={jN.recentorders}>Recent Order</h2>
        <div className={jN["search-bar"]}>
          <i className="bi bi-search" />
          <input type="text" placeholder="Search" value={z} onChange={e => x(e.target.value)} />
        </div>

        {y ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
            <BallTriangle height={50} width={55} radius={5} color="#af3585" ariaLabel="ball-triangle-loading" visible />
          </div>
        ) : g.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>No recent orders found.</div>
        ) : filteredOrders.length > 0 ? (
          filteredOrders.map((e) => (
            <div
              key={e.order_id}
              className={jN["order-item"]}
              onClick={() => N(`/app/orders/confirm/${e.order_id}`)}
            >
              <img
                src={e.customer_profile_image || "/assets/images/avatars/avatar_1.jpg"}
                alt="Customer Profile"
                className={jN["profile-image-placeholder"]}
              />
              <div className={jN["order-details"]}>
                <p className={jN["customer-name"]}>{e.customer_name}</p>
                <p className={jN["order-id"]}>{e.order_number}</p>
              </div>
              <div className={`${jN.status} ${jN[e.order_status.toLowerCase()]}`}>
                {e.order_status}
              </div>
              <div className={jN["order-amount"]}>
                ₦{e.total_cost ? e.total_cost.toLocaleString() : "0"}
                <p style={{ fontSize: "0.75rem", color: "#666", margin: 0, fontWeight: "normal" }}>
                  {new Date(e.date_ordered).toLocaleDateString()}
                </p>
              </div>
              <i className="bi bi-chevron-right" style={{ color: "#222", fontSize: "1.1rem" }} />
            </div>
          ))
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>No results found for "{z}"</div>
        )}
      </div>

      {/* Test Mode Modal */}
      <Modal open={testModeModal} onClose={() => setTestModeModal(false)}>
        <div style={{
          background: 'white',
          borderRadius: 20,
          maxWidth: 350,
          margin: '100px auto',
          padding: 32,
          boxShadow: '0 4px 32px rgba(0,0,0,0.15)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          outline: 'none',
        }}>
          <div style={{ fontSize: 48, color: '#f79009', marginBottom: 16 }}>⚠️</div>
          <h2 style={{ fontWeight: 700, fontSize: 22, margin: 0, marginBottom: 8, textAlign: 'center' }}>Currently on Test Mode</h2>
          <p style={{ color: '#475467', fontSize: 16, textAlign: 'center', marginBottom: 24 }}>
            Complete your profile to perform other transactions
          </p>
          <div style={{ display: 'flex', gap: 16, width: '100%' }}>
            <button
              style={{
                flex: 1,
                background: 'white',
                color: '#af3585',
                border: '2px solid #af3585',
                borderRadius: 8,
                padding: '10px 0',
                fontWeight: 500,
                fontSize: 16,
                cursor: 'pointer',
              }}
              onClick={() => setTestModeModal(false)}
            >
              Cancel
            </button>
            <button
              style={{
                flex: 1,
                background: '#af3585',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                padding: '10px 0',
                fontWeight: 500,
                fontSize: 16,
                cursor: 'pointer',
              }}
              onClick={() => {
                setTestModeModal(false);
                navigate('/app/profile?edit=1');
              }}
            >
              Complete profile
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MobileDashboard;
